// #region imports

// --- Angular
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

// #endregion

@Component({
  selector: 'hs-field-error',
  templateUrl: './field-error.component.html',
  styleUrls: ['./field-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldErrorComponent {
  @Input() errorMessage: string = '';
  @Input() labelFor: string = '';
  @Input() hideIcon: boolean = false;
}
